import PropTypes from "prop-types";


const ContentWrapper=({className,children})=>{

    return <div className={`t-content-wrapper  ${className} `}>
             {children}
          </div>
}
ContentWrapper.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
}
ContentWrapper.defaultProps = {
    className: "",
    children: "",

}
export default ContentWrapper;